module.exports = __webpack_public_path__ + "7744640e7959e2d4b9b1c0c6e1eb28dd.svg";